"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDarkMode = exports.disableDarkMode = exports.enableDarkMode = exports.removeRefreshToken = exports.getRefreshToken = exports.setRefreshToken = exports.removeToken = exports.getToken = exports.setToken = exports.getEnv = exports.setEnv = exports.clearState = exports.clearChallengePair = exports.getState = exports.getChallengePair = exports.store = void 0;

var _store = _interopRequireDefault(require("store2"));

var _pkce = require("pkce");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const store = _store.default.namespace("snowboard");

exports.store = store;
const challengePairStore = store.namespace("challenge-pair");
const tokenStore = store.namespace("token");
const refreshTokenStore = store.namespace("refresh-token");

const getChallengePair = () => {
  if (challengePairStore.keys().length === 0) {
    challengePairStore.setAll((0, _pkce.create)());
  }

  return challengePairStore.getAll();
};

exports.getChallengePair = getChallengePair;

const getState = () => {
  if (!store.has("state")) {
    store.set("state", (0, _pkce.random)(16));
  }

  return store.get("state");
};

exports.getState = getState;

const clearChallengePair = () => challengePairStore.clear();

exports.clearChallengePair = clearChallengePair;

const clearState = () => store.remove("state");

exports.clearState = clearState;

const setEnv = env => store.set("env", env);

exports.setEnv = setEnv;

const getEnv = () => store.get("env");

exports.getEnv = getEnv;

const setToken = (env, token) => tokenStore.set(env, token);

exports.setToken = setToken;

const getToken = env => tokenStore.get(env);

exports.getToken = getToken;

const removeToken = env => tokenStore.remove(env);

exports.removeToken = removeToken;

const setRefreshToken = (env, token) => refreshTokenStore.set(env, token);

exports.setRefreshToken = setRefreshToken;

const getRefreshToken = env => refreshTokenStore.get(env);

exports.getRefreshToken = getRefreshToken;

const removeRefreshToken = env => refreshTokenStore.remove(env);

exports.removeRefreshToken = removeRefreshToken;

const enableDarkMode = () => store.set("darkMode", true);

exports.enableDarkMode = enableDarkMode;

const disableDarkMode = () => store.set("darkMode", false);

exports.disableDarkMode = disableDarkMode;

const getDarkMode = () => store.get("darkMode");

exports.getDarkMode = getDarkMode;